"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickType = void 0;
var ClickType;
(function (ClickType) {
    ClickType["Select"] = "Select";
    ClickType["SlideNext"] = "Slide next";
    ClickType["SlidePrevious"] = "Slide previous";
    ClickType["OpenGallery"] = "open gallery";
    ClickType["CloseGallery"] = "close gallery";
    ClickType["DefaultUpper"] = "Default upper part";
    ClickType["StickyBottom"] = "Sticky at the bottom";
})(ClickType || (exports.ClickType = ClickType = {}));
//# sourceMappingURL=ClickType.js.map